import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import map from 'lodash/map';
import styles from './GridLogos.module.scss';
import { GridBackground } from './GridBackground';
import size from 'lodash/size';
import has from "lodash/has";

export const GridLogos = (props) => {
  const list = map([...props.list], (item) => {
    item.isHover = false
    return item
  })
  const [listState, setListState] = useState(list)
  const itemsRef = useRef([])
  const triggerElementRef = useRef(null)
  const triggerIdRef = useRef(null)
  const gridRef = useRef(null)
  const [ gridSize, setGridSize ] = useState(null);

  const handlerItemFocus = (index, accent, id) => {
    triggerElementRef.current = itemsRef.current[index]
    triggerIdRef.current = id

    if(accent) {
      document.body.style.setProperty('--effect-bg-accent-1', 'transparent')
      document.body.style.setProperty('--effect-bg-accent-2', accent[0])
      document.body.style.setProperty('--effect-bg-accent-3', accent[1])
      document.body.style.setProperty('--effect-bg-accent-4', 'transparent')
    }

    setListState((oldState) => oldState.map((item) => item.id === id ? { ...item, isHover: true } : item))
  }

  const handlerItemBlur = (id) => {
    triggerElementRef.current = null
    triggerIdRef.current = null

    document.body.style.removeProperty('--effect-bg-accent-1')
    document.body.style.removeProperty('--effect-bg-accent-2')
    document.body.style.removeProperty('--effect-bg-accent-3')
    document.body.style.removeProperty('--effect-bg-accent-4')

    setListState((oldState) => oldState.map((item) => item.id === id ? { ...item, isHover: false } : item))
  }

  const getItem = (item) => {
      return (<>
          <div className={classNames(styles.logo)}>
              <img
                  src={item.src.default}
                  width={item.width}
                  height={item.height}
                  alt={item.name}
              />
          </div>
          {item.signature && (
              <div className={styles.signature}>{item.signature}</div>
          )}</>)
  }

  useEffect(() => {
    if(gridRef.current) {
      setGridSize({
        width: gridRef.current.clientWidth,
        height: gridRef.current.clientHeight
      })
    }

    return () => {
      setGridSize(null)
    }
  }, [ gridRef ])

  return (
    <div className={ styles.container }>
      { gridSize && (
        <GridBackground
          className={ styles.background }
          cellLength={ size(listState) }
          cellColumns={ props.columns }
          gridWidth={ gridSize.width }
          gridHeight={ gridSize.height }
        />
      ) }
      <div
        className={ classNames(
          styles.grid,
          {
            [styles[`columns-${props.columns}`]]: props.columns
          }
        ) }
        ref={ gridRef }
      >
        { map(listState, (item, index) => (
          <div
            key={ index }
            className={ classNames(
              styles.item,
              {
                [styles.itemChange]: item.src?.hover,
                [styles.itemHover]: (item.isHover && item.src?.hover)
              }
            ) }
            ref={ (el) => itemsRef.current[index] = el }
            onMouseEnter={ () => handlerItemFocus(index, item.accent, item.id) }
            onMouseLeave={ () => handlerItemBlur(item.id) }
            style={ {
              '--hover-img': item.src.hover ? `url(${item.src.hover})` : false,
              '--desktop-width': item.width,
              '--mobile-width': item.widthMobile,
            } }
          >
              {has(item,'href') && (<a target="_blank" href={item.href}>{getItem(item)}</a>)}
              {!has(item,'href') && getItem(item)}
          </div>
        )) }
      </div>
    </div>
  )
}
